import React,{useState, useContext} from 'react'
import { GlobalContext } from '../../../context/provider';
import numberbeautify from '../../../utils/numberbeautify';
import money_rounding from '../../../utils/money_rounding';
import Loan_in_detail_modal from './loan_in_detail_modal';

const Loan_in_table = () => {
    const { initState } = useContext(GlobalContext);
    const [loan_in, setloan_in] = useState([]);
    const [show, setshow] = useState(false);
    return (
        <div className="mt-6">
            <Loan_in_detail_modal show={show} setshow={setshow} loan_in={loan_in} />
            {/* Category List Card */}
            <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto">
                
                {/* Section Header */}
                <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
                    <h2 className="text-base font-semibold text-slate-800">لیستی قەرزی گەڕاوە</h2>
                </div>

                {/* Table */}
                <table className="w-full">
                    <thead>
                        <tr className="bg-slate-50 border-b border-slate-100">
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                ناوی کڕیار
                            </th>
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                ناونیشان
                            </th>
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                ژمارە
                            </th>
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                بڕی قەرزی گەڕاوە
                            </th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-50">
                        {initState.loan_in_report.map((lis)=>(
                        <tr key={lis.customer_id} className="hover:bg-slate-50 transition-colors duration-100">
                            <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right underline" onClick={()=>{
                                setloan_in(lis.loan_in);
                                setshow(true);
                            }}>
                                <p className='cursor-pointer'>
                                    {lis.customer_name}
                                </p>
                            </td>
                            <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                {lis.customer_address}
                            </td>
                            <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                {lis.customer_phone} 
                            </td>
                            <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                {numberbeautify(money_rounding(lis.total_loan_in))} $
                            </td>
                        </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Loan_in_table